import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-trust-info-card',
  templateUrl: './trust-info-card.component.html',
  styleUrls: ['./trust-info-card.component.scss'],
  standalone: true,
  imports: [],
})
export class TrustInfoCardComponent {
  @Input() title: string = '';
}
